module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "frontMatterPage",
    attrs: {
      "id": "fm01"
    }
  }, [_c('p', {
    staticClass: "txt"
  }, [_c('span')]), _c('h3', {
    staticClass: "c10"
  }, [_vm._v("HISTORIAN'S NOTE")]), _c('br'), _c('p', {
    staticClass: "txtno"
  }, [_c('span', [_c('i', [_vm._v("The Trojan Spaceship")]), _vm._v(" takes place in the fourth season of STAR TREK: DEEP SPACE NINE.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6fd63c77","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/9780743420488_fm01.vue
// module id = 69
// module chunks = 0